import { gql } from "@apollo/client";

export const DELETE_AML_RULE_REFERENCE_EXCLUSION = gql`
  mutation deleteAmlRuleReferenceExclusion($input: DeleteForClientByIdInput!) {
    aml {
      deleteAmlRuleReferenceExclusion(input: $input) {
        success
      }
    }
  }
`;
